import { Reveal } from "@/components/Reveal";

/**
 * Editorial numbered section header. e.g.  "01 / Recent Work"
 */
export const SectionHeader = ({ index, eyebrow, title, description, align = "left", testid }) => {
  return (
    <div className={align === "center" ? "text-center max-w-2xl mx-auto" : "max-w-2xl"} data-testid={testid}>
      <Reveal>
        <div className={`flex items-center gap-3 mb-5 ${align === "center" ? "justify-center" : ""}`}>
          {index && <span className="font-heading text-sm text-ash tabular-nums">{index}</span>}
          <span className="h-px w-8 bg-white/20" />
          <span className="text-xs tracking-[0.2em] uppercase text-ash">{eyebrow}</span>
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-heading font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-cream text-balance">
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={0.1}>
          <p className="mt-5 text-ash text-base sm:text-lg leading-relaxed">{description}</p>
        </Reveal>
      )}
    </div>
  );
};

export default SectionHeader;
